import { CATEGORY_META, BellIcon } from "./Icons.jsx";
import { fmtDate } from "../lib/dates.js";

/** Split text on a query so matches can be wrapped in <mark>. */
function highlight(text, query) {
  if (!query || !text) return text;
  const safe = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = String(text).split(new RegExp(`(${safe})`, "ig"));
  return parts.map((part, i) =>
    part.toLowerCase() === query.toLowerCase() ? <mark key={i}>{part}</mark> : part
  );
}

const relative = (ts) => {
  if (!ts) return "";
  const diff = Date.now() - ts;
  const day = 86_400_000;
  if (diff < 60_000) return "just now";
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)}m ago`;
  if (diff < day) return `${Math.floor(diff / 3_600_000)}h ago`;
  if (diff < 7 * day) return `${Math.floor(diff / day)}d ago`;
  return new Date(ts).toLocaleDateString(undefined, { day: "numeric", month: "short" });
};

export function EntryCard({ entry, query, onOpen, view }) {
  const meta = CATEGORY_META[entry.category] || CATEGORY_META.diary;
  const { Icon } = meta;

  const due = entry.alertEnabled && entry.alertDate;
  const overdue = due && new Date(entry.alertDate) <= new Date();

  // Password secrets never appear in a list — only the label and username do.
  const snippet =
    entry.category === "password"
      ? [entry.username, entry.url].filter(Boolean).join(" · ") || "No username saved"
      : (entry.content || "").slice(0, 220);

  return (
    <button
      className={`entry-card ${overdue ? "due" : ""}`}
      style={{ "--cat": meta.color }}
      onClick={() => onOpen(entry)}
    >
      <span className="entry-ico"><Icon size={17} /></span>

      <span className="entry-main">
        <span className="entry-title truncate">
          {highlight(entry.title || "Untitled", query)}
        </span>

        {view !== "icons" && (
          <span className="entry-snippet">{highlight(snippet, query)}</span>
        )}

        {view !== "icons" && (
          <span className="entry-meta">
            <span>{meta.label}</span>
            <span>·</span>
            <span>{relative(entry.updatedAt || entry.createdAt)}</span>
            {overdue && (
              <span className="badge warning">
                <BellIcon size={11} /> {fmtDate(new Date(entry.alertDate))}
              </span>
            )}
            {entry.tags?.slice(0, 3).map((t) => (
              <span className="tag" key={t}>{highlight(t, query)}</span>
            ))}
            {entry.tags?.length > 3 && <span className="muted">+{entry.tags.length - 3}</span>}
          </span>
        )}
      </span>
    </button>
  );
}

export function EntryList({ entries, query, view = "list", onOpen }) {
  return (
    <div className={`entry-grid ${view}`}>
      {entries.map((entry) => (
        <EntryCard key={entry.id} entry={entry} query={query} view={view} onOpen={onOpen} />
      ))}
    </div>
  );
}
